import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks/hooks";
import { selectSubmitCounter, setSubmitCount } from "../../../redux/slices/submitCounterSlice";
import { useTranslation } from "react-i18next";

interface IDetailViewPostButtonProps {
  onPost: () => void;
  showOnPost?: boolean;
}

const DetailViewPostButton = ({ onPost, showOnPost }: IDetailViewPostButtonProps) => {
  const [postClicked, setPostClicked] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const counter = useAppSelector(selectSubmitCounter);
  const { t } = useTranslation();

  const handlePostClick = async () => {
    setPostClicked(true);
    await onPost();
    dispatch(setSubmitCount(counter + 1));
    setPostClicked(false);
  };

  return (
    <>
      {!showOnPost && (
        <button type={"button"} className="btn btn-success me-2 d-flex align-items-center" onClick={handlePostClick}>
          {postClicked ? (
            <>
              <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i>
              {t("Posting")}
            </>
          ) : (
            <>
              <i className="fa-solid fa-circle-check me-2"></i>
              {t("Post")}
            </>
          )}
        </button>
      )}
    </>
  );
};

export default DetailViewPostButton;
